import { PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';
var FileSizePipe = /** @class */ (function () {
    function FileSizePipe(decimalPipe) {
        this.decimalPipe = decimalPipe;
    }
    FileSizePipe.prototype.transform = function (value, decimals) {
        var _sizebreaks = [0, 1000, 1000000, 1000000000, 1000000000000];
        var _sizeextents = ['B', 'kB', 'MB', 'GB', 'TB'];
        if (!value) {
            return '';
        }
        for (var i = _sizebreaks.length - 1; i >= 0; --i) {
            if (_sizebreaks[i] <= value) {
                var major = (_sizebreaks[i] > 0 ? (value * 1.0 / _sizebreaks[i]) : value);
                var minor = (decimals != null ? decimals : 2);
                return this.decimalPipe.transform(major, "1." + minor + "-" + minor) + " " + _sizeextents[i];
            }
        }
    };
    return FileSizePipe;
}());
export { FileSizePipe };
